import type { FunctionComponent } from 'react';
import styled from 'styled-components';
import { paletteHelper, spacingHelper, typographyHelper } from '@property.com.au/ui-kit';

const EnergyEfficiencyGaugeImage = styled.img`
  width: 100px;
  height: 100%;
`;

const EnergyEfficiencyGaugeContainer = styled.div`
  margin-right: ${spacingHelper('small')};
  margin-left: ${spacingHelper('twoExtraLarge')};

  display: flex;
  flex-direction: column;
  align-items: center;
`;

const EnergyEfficiencyGaugeText = styled.div`
  ${typographyHelper('overline')}
  color: ${paletteHelper('textSecondary')};
  margin-top: ${spacingHelper('twoExtraSmall')};
`;

const roundToNearestHalf = (value: number): number => {
  return Math.round(value * 2) / 2;
};

export const energyEfficiencyMapper = (energyEfficiency: number): string | null => {
  const numberRoundedToNearestHalf = roundToNearestHalf(energyEfficiency);

  if (numberRoundedToNearestHalf > 10 || numberRoundedToNearestHalf < 0) {
    return null;
  }

  return `${numberRoundedToNearestHalf.toFixed(1)}.png`;
};

interface EnergyEfficiencyGaugeProps {
  energyEfficiency: number;
}

export const EnergyEfficiencyGauge: FunctionComponent<EnergyEfficiencyGaugeProps> = ({
  energyEfficiency,
}) => {
  const energyEfficiencyGaugeImage = energyEfficiencyMapper(energyEfficiency);

  if (!energyEfficiencyGaugeImage) return null;

  return (
    <EnergyEfficiencyGaugeContainer>
      <EnergyEfficiencyGaugeImage
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-require-imports
        src={require(`../../../../../../../assets/energy-efficiency/${energyEfficiencyGaugeImage}`)}
        alt={`${energyEfficiency.toFixed(1)}-energy-efficiency-logo`}
        loading="lazy"
      />
      <EnergyEfficiencyGaugeText>{energyEfficiency.toFixed(1)} EER</EnergyEfficiencyGaugeText>
    </EnergyEfficiencyGaugeContainer>
  );
};
